import { useState, useEffect, useRef } from 'react'
import { supabase } from './supabase'

function stripBrand(name, brand) {
  if (!brand || !name) return name || ''
  const escaped = brand.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  return name.replace(new RegExp('^' + escaped + '\\s*', 'i'), '').trim() || name
}

function getItemEmoji(item) {
  if (item.emoji && item.emoji !== '🛒') return item.emoji
  const n = (item.name || '').toLowerCase()
  if (/\bonion|shallot/.test(n)) return '🧅'
  if (/\bgarlic/.test(n)) return '🧄'
  if (/\btomato/.test(n)) return '🍅'
  if (/\blettuce|romaine|iceberg|arugula/.test(n)) return '🥬'
  if (/\bspinach|kale/.test(n)) return '🥬'
  if (/\bbell pepper|pepper/.test(n)) return '🫑'
  if (/\bjalape|chili|chile/.test(n)) return '🌶️'
  if (/\bbroccoli/.test(n)) return '🥦'
  if (/\bmushroom/.test(n)) return '🍄'
  if (/\bavocado/.test(n)) return '🥑'
  if (/\blemon|lime/.test(n)) return '🍋'
  if (/\bbanana/.test(n)) return '🍌'
  if (/\bapple/.test(n)) return '🍎'
  if (/\bstrawberr|raspberr/.test(n)) return '🍓'
  if (/\bblueberr/.test(n)) return '🫐'
  if (/\bgrape/.test(n)) return '🍇'
  if (/\borange/.test(n)) return '🍊'
  if (/\bcarrot/.test(n)) return '🥕'
  if (/\bcorn/.test(n)) return '🌽'
  if (/\bcucumber|zucchini/.test(n)) return '🥒'
  if (/\bcelery/.test(n)) return '🥬'
  if (/\bsweet potato|yam/.test(n)) return '🍠'
  if (/\bpotato/.test(n)) return '🥔'
  if (/\bsnap pea|pea/.test(n)) return '🫛'
  if (/\bbean/.test(n)) return '🫘'
  if (/\bginger/.test(n)) return '🫚'
  if (/\bchicken/.test(n)) return '🍗'
  if (/\bturkey/.test(n)) return '🦃'
  if (/\bbacon/.test(n)) return '🥓'
  if (/\bsausage|bratwurst/.test(n)) return '🌭'
  if (/\bsalmon|tilapia|cod|tuna|fish/.test(n)) return '🐟'
  if (/\bshrimp|prawn/.test(n)) return '🦐'
  if (/\bbeef|steak|chuck|ground/.test(n)) return '🥩'
  if (/\bpork|ham/.test(n)) return '🥩'
  if (/\begg|eggs/.test(n)) return '🥚'
  if (/\bbutter/.test(n)) return '🧈'
  if (/\bcheese|parmesan|mozzarella|cheddar/.test(n)) return '🧀'
  if (/\bmilk|cream|yogurt/.test(n)) return '🥛'
  if (/\btortilla|wrap/.test(n)) return '🫓'
  if (/\bbagel/.test(n)) return '🥯'
  if (/\bcroissant/.test(n)) return '🥐'
  if (/\bbread|loaf|roll|bun/.test(n)) return '🍞'
  if (/\bpita/.test(n)) return '🫓'
  if (/\bpancake|waffle/.test(n)) return '🥞'
  if (/\bpasta|spaghetti|noodle|penne|fettuccine|linguine/.test(n)) return '🍝'
  if (/\brice/.test(n)) return '🍚'
  if (/\bolive oil|oil/.test(n)) return '🫒'
  if (/\bsalt/.test(n)) return '🧂'
  if (/\bhoney/.test(n)) return '🍯'
  if (/\bbroth|stock|soup/.test(n)) return '🍲'
  if (/\bsalsa/.test(n)) return '🫙'
  if (/\bketchup/.test(n)) return '🍅'
  if (/\bpopcorn|chip|crisp/.test(n)) return '🍿'
  if (/\bcereal|oat/.test(n)) return '🥣'
  if (/\bcoffee/.test(n)) return '☕'
  if (/\btea/.test(n)) return '🍵'
  if (/\bjuice/.test(n)) return '🧃'
  if (/\bsoda|cola/.test(n)) return '🥤'
  if (/\bwine/.test(n)) return '🍷'
  if (/\bbeer/.test(n)) return '🍺'
  if (/\bchocolate|cocoa/.test(n)) return '🍫'
  if (/\bcookie|biscuit/.test(n)) return '🍪'
  if (/\bnut|almond|cashew|walnut|peanut/.test(n)) return '🥜'
  if (/\bice cream/.test(n)) return '🍦'
  if (/\bfrozen/.test(n)) return '🧊'
  if (/\bsoap|detergent|dish/.test(n)) return '🧴'
  if (/\bpaper towel|toilet|tissue/.test(n)) return '🧻'
  return '🛒'
}

const GROCERY_CATEGORIES = ['Produce', 'Meat', 'Dairy', 'Bakery', 'Pantry', 'Frozen', 'Other']

const ITEM_EMOJIS = [
  '🍅','🥬','🫑','🧅','🧄','🥦','🍄','🥑','🍋','🍌','🍎','🍓','🫐','🍇','🍊','🥕','🌽','🥒','🥔','🍠','🫛','🫚','🌶️',
  '🍗','🥩','🥓','🌭','🦃','🐟','🦐','🥚',
  '🥛','🧀','🧈','🫙',
  '🍞','🫓','🥐','🥯','🥞',
  '🍝','🍚','🥣','🍲','🍯','🧂','🫒','🥫','🍿','☕','🍵','🧃','🥤','🍷','🍺',
  '🍪','🍫','🍦','🎂','🧁','🍩',
  '🧴','🧻','🧺','🛒',
]
const CATEGORY_RANK = { Produce: 0, Meat: 1, Dairy: 2, Bakery: 3, Pantry: 4, Frozen: 5, Other: 6 }

function getGroceryCategory(item) {
  const name = (item.name || '').toLowerCase()
  const emoji = item.emoji || ''

  // Priority: specific product names checked before flavor/ingredient words can misroute them

  // Pantry: soups, broths, stocks — caught before chicken/beef/turkey match Meat
  if (/\bbroth\b|\bstock\b|\bbouillon\b|\bsoup\b|\bchowder\b/.test(name)) return 'Pantry'
  // Pantry: dips & spreads
  if (/hummus|guacamole|tzatziki|pesto|tahini|aioli|tapenade|spinach dip|spinach artichoke/.test(name)) return 'Pantry'
  // Pantry: tomato-based products (not the fresh vegetable)
  if (/tomato sauce|tomato paste|tomato juice|crushed tomato|diced tomato|stewed tomato|sun.dried tomato|marinara|pasta sauce/.test(name)) return 'Pantry'
  // Pantry: powdered/dried produce and spices with produce names
  if (/garlic powder|garlic salt|garlic seasoning|onion powder|onion flakes|onion seasoning|celery salt|celery seed|ginger powder|ground ginger|lemon pepper|black pepper|white pepper|red pepper flake|cayenne pepper/.test(name)) return 'Pantry'
  // Pantry: ground spices (before bare 'ground' in Meat catches them)
  if (/ground (?:cinnamon|nutmeg|cloves|cumin|cardamom|ginger|turmeric|allspice|pepper|coffee)/.test(name)) return 'Pantry'
  // Pantry: produce-named beverages & extracts
  if (/apple (?:juice|cider|sauce)|applesauce|lemon juice|lime juice|banana chip|avocado oil|ginger (?:ale|beer)/.test(name)) return 'Pantry'

  // Dairy: flavor-named dairy products
  if (/pepper jack|jalapeño.*cheese|garlic.*cheese/.test(name)) return 'Dairy'

  // Bakery: flavor-named baked goods
  if (/garlic bread|garlic knot|garlic roll|banana bread|spinach tortilla|spinach wrap/.test(name)) return 'Bakery'

  // General categories
  if (/tomato|lettuce|spinach|pepper|onion|garlic|broccoli|mushroom|avocado|lemon|lime|banana|apple|berry|berries|fruit|vegetable|salad|romaine|iceberg|snap pea|ginger|celery|carrot|cucumber|zucchini/.test(name)
    || ['🍅','🥬','🫑','🧅','🧄','🥦','🍄','🥑','🍋','🍌','🍎','🫐','🥗','🌽','🥕'].includes(emoji)) {
    return 'Produce'
  }
  // Meat — 'ground' only matches when followed by a meat type
  if (/chicken|beef|turkey|bacon|sausage|pork|ground (?:beef|pork|turkey|chicken|lamb|meat)|steak|chuck|thigh|breast|hot dog|pepperoni|patty|patties|\bham\b/.test(name)
    || ['🥩','🍗','🥓','🌭'].includes(emoji)) {
    return 'Meat'
  }
  if (/milk|cheese|butter|yogurt|cream|parmesan|mozzarella|cheddar|sour cream|egg|eggs/.test(name)
    || ['🥛','🧀','🧈','🥚','🫙'].includes(emoji)) {
    return 'Dairy'
  }
  if (/bread|bun|tortilla|roll|bagel|pita|wrap|dough|pizza dough|pancake mix|bisquick|muffin|donut|doughnut|danish|scone|brioche|croissant/.test(name)
    || ['🍞','🫓','🥐','🥖'].includes(emoji)) {
    return 'Bakery'
  }
  if (/frozen|ice cream/.test(name)) return 'Frozen'
  if (/sauce|oil|seasoning|spice|salt|pepper|sugar|flour|rice|pasta|spaghetti|noodle|broth|soup|can|jar|ketchup|mustard|mayo|syrup|honey|oat|cereal|chip|cracker|cookie|biscuit|nut|popcorn|salsa|dressing|vinegar|soy|taco|fajita/.test(name)
    || ['🫙','🥫','🍯','🫒','🧂'].includes(emoji)) {
    return 'Pantry'
  }
  return 'Other'
}

export default function Cart({ user, onBack }) {
  const [cartBundles, setCartBundles] = useState([])
  const [cartItems, setCartItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [view, setView] = useState('bundle')
  const [checkedItems, setCheckedItems] = useState({})
  const [sentToStore, setSentToStore] = useState(false)
  const [removedItems, setRemovedItems] = useState({})
  const [householdId, setHouseholdId] = useState(null)
  const [cartSearch, setCartSearch] = useState('')
  const [cartSearchResults, setCartSearchResults] = useState([])
  const [cartSearching, setCartSearching] = useState(false)
  const [addingItem, setAddingItem] = useState(null)
  const [editingCartOrder, setEditingCartOrder] = useState(false)
  const [categoryOverrides, setCategoryOverrides] = useState({})
  const [editSections, setEditSections] = useState(null)
  const [emojiPickerItemId, setEmojiPickerItemId] = useState(null)
  const [showClearConfirm, setShowClearConfirm] = useState(false)
  const cartSearchRef = useRef(null)

  useEffect(() => { fetchCart() }, [])

  useEffect(() => {
    if (cartSearch.length < 2) { setCartSearchResults([]); return }
    const timer = setTimeout(() => doCartSearch(cartSearch), 300)
    return () => clearTimeout(timer)
  }, [cartSearch])

  async function fetchCart() {
    setLoading(true)
    const { data: membership } = await supabase
      .from('household_members').select('household_id').eq('user_id', user.id).single()
    if (!membership) { setLoading(false); return }
    setHouseholdId(membership.household_id)

    const initChecked = {}
    const initCategoryOverrides = {}

    const { data: bundles } = await supabase
      .from('bundles').select('*')
      .eq('household_id', membership.household_id).eq('in_cart', true)
      .order('created_at', { ascending: false })
    if (bundles && bundles.length > 0) {
      const bundlesWithItems = await Promise.all(
        bundles.map(async bundle => {
          const { data: items } = await supabase
            .from('bundle_items').select('*').eq('bundle_id', bundle.id).neq('in_cart', false)
          return { ...bundle, items: items || [] }
        })
      )
      setCartBundles(bundlesWithItems)
      bundlesWithItems.forEach(bundle => {
        bundle.items.forEach(item => {
          initChecked[item.id] = item.checked || false
          if (item.custom_category) initCategoryOverrides[item.id] = item.custom_category
        })
      })
    }

    const { data: indivItems } = await supabase
      .from('cart_items').select('*')
      .eq('household_id', membership.household_id).order('created_at', { ascending: true })
    if (indivItems) {
      setCartItems(indivItems)
      indivItems.forEach(item => {
        initChecked[item.id] = item.checked || false
        if (item.custom_category) initCategoryOverrides[item.id] = item.custom_category
      })
    }

    setCheckedItems(initChecked)
    setCategoryOverrides(initCategoryOverrides)
    setLoading(false)
  }

  async function toggleItem(itemId) {
    const newVal = !checkedItems[itemId]
    setCheckedItems(prev => ({ ...prev, [itemId]: newVal }))
    await supabase.from('bundle_items').update({ checked: newVal }).eq('id', itemId)
  }

  async function toggleCartItem(itemId) {
    const newVal = !checkedItems[itemId]
    setCheckedItems(prev => ({ ...prev, [itemId]: newVal }))
    await supabase.from('cart_items').update({ checked: newVal }).eq('id', itemId)
  }

  async function toggleAllInBundle(bundle) {
    const visibleItems = bundle.items.filter(i => !removedItems[i.id])
    const allChecked = visibleItems.every(item => checkedItems[item.id])
    const newVal = !allChecked
    const updated = { ...checkedItems }
    visibleItems.forEach(item => { updated[item.id] = newVal })
    setCheckedItems(updated)
    await Promise.all(visibleItems.map(item =>
      supabase.from('bundle_items').update({ checked: newVal }).eq('id', item.id)
    ))
  }

  async function doCartSearch(q) {
    setCartSearching(true)
    try {
      const res = await fetch(`/api/kroger?query=${encodeURIComponent(q)}`)
      const data = await res.json()
      setCartSearchResults((data.data || []).slice(0, 6).map(p => ({
        name: stripBrand(p.description, p.brand),
        brand: p.brand || '',
        size: p.items?.[0]?.size || '',
        price: p.items?.[0]?.price?.regular || 0,
        kroger_sku: p.productId,
      })))
    } catch { setCartSearchResults([]) }
    setCartSearching(false)
  }

  async function addSearchedItem(item) {
    if (!householdId) return
    setAddingItem(item.name)
    const { data: newItem } = await supabase.from('cart_items').insert({
      household_id: householdId,
      name: item.name, brand: item.brand || '', size: item.size || '',
      price: item.price || 0, emoji: '🛒',
      kroger_sku: item.kroger_sku || null, quantity: 1, checked: false,
    }).select().single()
    if (newItem) {
      setCartItems(prev => [...prev, newItem])
      setCheckedItems(prev => ({ ...prev, [newItem.id]: false }))
    }
    setCartSearch('')
    setCartSearchResults([])
    setAddingItem(null)
  }

  async function removeBundle(bundleId) {
    await supabase.from('bundles').update({ in_cart: false }).eq('id', bundleId)
    await supabase.from('bundle_items').update({ in_cart: true, checked: false, custom_category: null }).eq('bundle_id', bundleId)
    setCartBundles(prev => prev.filter(b => b.id !== bundleId))
  }

  async function removeItem(itemId) {
    await supabase.from('bundle_items').update({ in_cart: false }).eq('id', itemId)
    setRemovedItems(prev => ({ ...prev, [itemId]: true }))
  }

  async function removeCartItem(itemId) {
    await supabase.from('cart_items').delete().eq('id', itemId)
    setCartItems(prev => prev.filter(i => i.id !== itemId))
  }

  async function updateQuantity(itemId, delta) {
    const item = bundleItems.find(i => i.id === itemId)
    if (!item) return
    const newQty = Math.max(1, (item.quantity || 1) + delta)
    await supabase.from('bundle_items').update({ quantity: newQty }).eq('id', itemId)
    setCartBundles(prev => prev.map(bundle => ({
      ...bundle,
      items: bundle.items.map(i => i.id === itemId ? { ...i, quantity: newQty } : i),
    })))
  }

  async function updateCartItemQuantity(itemId, delta) {
    const item = cartItems.find(i => i.id === itemId)
    if (!item) return
    const newQty = Math.max(1, (item.quantity || 1) + delta)
    await supabase.from('cart_items').update({ quantity: newQty }).eq('id', itemId)
    setCartItems(prev => prev.map(i => i.id === itemId ? { ...i, quantity: newQty } : i))
  }

  async function updateItemEmoji(itemId, emoji) {
    const isCartItem = cartItems.some(i => i.id === itemId)
    if (isCartItem) {
      setCartItems(prev => prev.map(i => i.id === itemId ? { ...i, emoji } : i))
      await supabase.from('cart_items').update({ emoji }).eq('id', itemId)
    } else {
      setCartBundles(prev => prev.map(b => ({
        ...b,
        items: b.items.map(i => i.id === itemId ? { ...i, emoji } : i),
      })))
      await supabase.from('bundle_items').update({ emoji }).eq('id', itemId)
    }
    setEmojiPickerItemId(null)
  }

  function startEditingOrder() {
    const sections = {}
    GROCERY_CATEGORIES.forEach(cat => { sections[cat] = [] })
    const allForEdit = [...bundleItems, ...cartItems]
    allForEdit.sort((a, b) => {
      const ra = CATEGORY_RANK[categoryOverrides[a.id] || getGroceryCategory(a)] ?? 99
      const rb = CATEGORY_RANK[categoryOverrides[b.id] || getGroceryCategory(b)] ?? 99
      if (ra !== rb) return ra - rb
      if (a.cart_order != null && b.cart_order != null) return a.cart_order - b.cart_order
      if (a.bundle_order != null && b.bundle_order != null) return a.bundle_order - b.bundle_order
      return 0
    })
    allForEdit.forEach(item => {
      const cat = categoryOverrides[item.id] || getGroceryCategory(item)
      sections[cat].push(item)
    })
    setEditSections(sections)
    setEditingCartOrder(true)
  }

  function moveItemInSection(item, direction) {
    setEditSections(prev => {
      const currentCat = GROCERY_CATEGORIES.find(cat => prev[cat].some(i => i.id === item.id))
      if (!currentCat) return prev
      const catIdx = GROCERY_CATEGORIES.indexOf(currentCat)
      const sectionItems = prev[currentCat]
      const itemIdx = sectionItems.findIndex(i => i.id === item.id)
      const newSections = {}
      GROCERY_CATEGORIES.forEach(c => { newSections[c] = [...prev[c]] })
      if (direction === -1 && itemIdx === 0) {
        if (catIdx === 0) return prev
        const newCat = GROCERY_CATEGORIES[catIdx - 1]
        newSections[currentCat] = newSections[currentCat].filter(i => i.id !== item.id)
        newSections[newCat] = [...newSections[newCat], item]
      } else if (direction === 1 && itemIdx === sectionItems.length - 1) {
        if (catIdx === GROCERY_CATEGORIES.length - 1) return prev
        const newCat = GROCERY_CATEGORIES[catIdx + 1]
        newSections[currentCat] = newSections[currentCat].filter(i => i.id !== item.id)
        newSections[newCat] = [item, ...newSections[newCat]]
      } else {
        const [moved] = newSections[currentCat].splice(itemIdx, 1)
        newSections[currentCat].splice(itemIdx + direction, 0, moved)
      }
      return newSections
    })
  }

  async function doneEditingOrder() {
    if (!editSections) { setEditingCartOrder(false); return }
    const cartItemIds = new Set(cartItems.map(i => i.id))
    const newOverrides = {}
    let globalOrder = 0
    const bundleUpdates = []
    const cartItemUpdates = []
    GROCERY_CATEGORIES.forEach(cat => {
      editSections[cat].forEach(item => {
        const customCat = cat !== getGroceryCategory(item) ? cat : null
        if (customCat) newOverrides[item.id] = customCat
        if (!cartItemIds.has(item.id)) {
          bundleUpdates.push({ id: item.id, cart_order: globalOrder, custom_category: customCat })
        } else {
          cartItemUpdates.push({ id: item.id, custom_category: customCat })
        }
        globalOrder++
      })
    })
    setCategoryOverrides(newOverrides)
    if (bundleUpdates.length > 0) {
      const orderMap = {}
      bundleUpdates.forEach(u => { orderMap[u.id] = u.cart_order })
      setCartBundles(prev => prev.map(bundle => ({
        ...bundle,
        items: bundle.items.map(i => {
          const u = bundleUpdates.find(x => x.id === i.id)
          return u ? { ...i, cart_order: u.cart_order, custom_category: u.custom_category } : i
        }),
      })))
      await Promise.all(bundleUpdates.map(u =>
        supabase.from('bundle_items').update({ cart_order: u.cart_order, custom_category: u.custom_category }).eq('id', u.id)
      ))
    }
    if (cartItemUpdates.length > 0) {
      setCartItems(prev => prev.map(i => {
        const u = cartItemUpdates.find(x => x.id === i.id)
        return u ? { ...i, custom_category: u.custom_category } : i
      }))
      await Promise.all(cartItemUpdates.map(u =>
        supabase.from('cart_items').update({ custom_category: u.custom_category }).eq('id', u.id)
      ))
    }
    setEditSections(null)
    setEditingCartOrder(false)
  }

  async function clearCart() {
    if (cartBundles.length > 0) {
      await supabase.from('bundles').update({ in_cart: false }).in('id', cartBundles.map(b => b.id))
      await Promise.all(cartBundles.map(b =>
        supabase.from('bundle_items').update({ in_cart: false, checked: false, cart_order: null, custom_category: null }).eq('bundle_id', b.id)
      ))
    }
    if (householdId) {
      await supabase.from('cart_items').delete().eq('household_id', householdId)
    }
    setCartBundles([])
    setCartItems([])
    setCheckedItems({})
    setRemovedItems({})
    setCategoryOverrides({})
    setShowClearConfirm(false)
  }

  async function clearCartWithHistory() {
    if (householdId && cartBundles.length > 0) {
      const d = new Date()
      const day = d.getDay()
      d.setDate(d.getDate() - (day === 0 ? 6 : day - 1))
      d.setHours(0, 0, 0, 0)
      const weekStart = d.toISOString().split('T')[0]

      const { data: existing } = await supabase
        .from('meal_plan_entries')
        .select('bundle_id')
        .eq('household_id', householdId)
        .eq('week_start', weekStart)

      const alreadyLogged = new Set((existing || []).map(e => e.bundle_id))
      const toInsert = cartBundles
        .filter(b => !alreadyLogged.has(b.id))
        .map(b => ({
          household_id: householdId,
          bundle_id: b.id,
          week_start: weekStart,
          section: b.category || 'misc',
          days: [],
          added_by: user.id,
        }))

      if (toInsert.length > 0) {
        await supabase.from('meal_plan_entries').insert(toInsert)
      }
    }
    await clearCart()
  }

  async function sendToStore() {
    if (cartBundles.length > 0) {
      await supabase.from('bundles').update({ in_cart: false }).in('id', cartBundles.map(b => b.id))
      await Promise.all(cartBundles.map(b =>
        supabase.from('bundle_items').update({ in_cart: true, checked: false, custom_category: null }).eq('bundle_id', b.id)
      ))
    }
    if (householdId) {
      await supabase.from('cart_items').delete().eq('household_id', householdId)
    }
    setSentToStore(true)
  }

  // Derived
  const bundleItems = cartBundles
    .flatMap(b => b.items.map(i => ({ ...i, bundleName: b.name, bundleEmoji: b.emoji })))
    .filter(i => !removedItems[i.id])
  const allItems = [...bundleItems, ...cartItems]
  const cartItemIds = new Set(cartItems.map(i => i.id))
  const checkedCount = allItems.filter(i => checkedItems[i.id]).length
  const total = allItems.filter(i => checkedItems[i.id]).reduce((sum, i) => sum + (i.price * (i.quantity || 1)), 0)

  // Grouped by effective category — no duplicates
  const itemCategoryGroups = GROCERY_CATEGORIES.map(cat => ({
    category: cat,
    items: allItems
      .filter(i => (categoryOverrides[i.id] || getGroceryCategory(i)) === cat)
      .sort((a, b) => {
        if (a.cart_order != null && b.cart_order != null) return a.cart_order - b.cart_order
        if (a.cart_order != null) return -1
        if (b.cart_order != null) return 1
        if (a.bundle_order != null && b.bundle_order != null) return a.bundle_order - b.bundle_order
        return 0
      }),
  })).filter(g => g.items.length > 0)

  const firstNonEmptyCat = editSections && GROCERY_CATEGORIES.find(c => editSections[c].length > 0)
  const lastNonEmptyCat = editSections && [...GROCERY_CATEGORIES].reverse().find(c => editSections[c].length > 0)

  if (sentToStore) {
    return (
      <div style={styles.container}>
        <div style={styles.successScreen}>
          <div style={styles.successIcon}>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M6 16l7 7 13-13" stroke="#1D9E75" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div style={styles.successTitle}>Order sent.</div>
          <div style={styles.successSub}>Your list is ready. Head to your store app to pay and confirm your pickup.</div>
          <div style={styles.notifPill}>You'll get a notification when your store confirms</div>
          <div style={styles.successActions}>
            <button style={styles.krogerBtn} onClick={onBack}>Back to bundle</button>
            <div style={styles.historyNote}>Need to check your order? Find it in Plan - History anytime.</div>
            <button style={styles.homeBtn} onClick={onBack}>Back to Bundle</button>
          </div>
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.navBar}>
          <button style={styles.backBtn} onClick={onBack}>Back</button>
        </div>
        <div style={styles.emptyScreen}>
          <div style={styles.emptyText}>Loading your cart...</div>
        </div>
      </div>
    )
  }

  if (cartBundles.length === 0 && cartItems.length === 0) {
    return (
      <div style={styles.container}>
        <div style={styles.navBar}>
          <button style={styles.backBtn} onClick={onBack}>Back</button>
          <div style={styles.navTitle}>Cart</div>
          <div style={{ width: 44 }} />
        </div>
        <div style={styles.emptyScreen}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🛒</div>
          <div style={styles.emptyTitle}>Your cart is empty</div>
          <div style={styles.emptySub}>Head to Bundles to add meals to your week, then come back here to shop.</div>
          <button style={styles.browsBtn} onClick={onBack}>Browse bundles</button>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <div style={styles.navBar}>
        <button style={styles.backBtn} onClick={onBack}>Back</button>
        <div style={styles.navTitle}>Your cart</div>
        <button style={styles.clearCartBtn} onClick={() => setShowClearConfirm(true)}>Clear cart</button>
      </div>
      <div style={styles.cartSearchWrap}>
        <div style={styles.cartSearchRow}>
          <span style={{ fontSize: '14px', flexShrink: 0 }}>🔍</span>
          <input
            ref={cartSearchRef}
            style={styles.cartSearchInput}
            placeholder="Add an item to cart…"
            value={cartSearch}
            onChange={e => setCartSearch(e.target.value)}
          />
          {cartSearching && <span style={{ fontSize: '12px', color: '#aaa' }}>…</span>}
          {cartSearch.length > 0 && (
            <button style={styles.cartSearchClear} onClick={() => { setCartSearch(''); setCartSearchResults([]) }}>✕</button>
          )}
        </div>
        {cartSearch.length >= 2 && (
          <div style={styles.cartSearchDropdown}>
            <div style={styles.cartManualRow} onClick={() => addSearchedItem({ name: cartSearch, brand: '', size: '', price: 0, kroger_sku: null })}>
              <div style={{ flex: 1 }}>
                <div style={styles.cartResultName}>Add "{cartSearch}" manually</div>
                <div style={styles.cartResultMeta}>No price · custom item</div>
              </div>
              <button style={styles.cartAddBtn} disabled={addingItem === cartSearch}>
                {addingItem === cartSearch ? '…' : '+'}
              </button>
            </div>
            {cartSearchResults.map((item, i) => (
              <div key={i} style={styles.cartResultRow} onClick={() => addSearchedItem(item)}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={styles.cartResultName}>{item.name}</div>
                  <div style={styles.cartResultMeta}>{item.brand}{item.size ? ` · ${item.size}` : ''}</div>
                </div>
                <span style={styles.cartResultPrice}>${item.price?.toFixed(2)}</span>
                <button style={styles.cartAddBtn} disabled={addingItem === item.name}>
                  {addingItem === item.name ? '…' : '+'}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={styles.toggleRow}>
        <button
          style={{ ...styles.toggleBtn, ...(view === 'bundle' ? styles.toggleBtnActive : {}) }}
          onClick={() => setView('bundle')}
        >By bundle</button>
        <button
          style={{ ...styles.toggleBtn, ...(view === 'list' ? styles.toggleBtnActive : {}) }}
          onClick={() => setView('list')}
        >By item type</button>
      </div>
      {view === 'list' && allItems.length > 1 && (
        <div style={styles.editOrderRow}>
          <button style={styles.editOrderBtn} onClick={() => editingCartOrder ? doneEditingOrder() : startEditingOrder()}>
            {editingCartOrder ? 'Done' : 'Edit order'}
          </button>
        </div>
      )}

      <div style={styles.content}>
        {view === 'bundle' ? (
          <div>
            {cartBundles.map(bundle => (
              <div key={bundle.id} style={styles.bundleGroup}>
                <div style={styles.groupHeader}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }} onClick={() => toggleAllInBundle(bundle)}>
                    <span style={styles.groupEmoji}>{bundle.emoji}</span>
                    <span style={styles.groupName}>{bundle.name}</span>
                    <span style={styles.groupCount}>
                      {bundle.items.filter(i => !removedItems[i.id] && checkedItems[i.id]).length}/{bundle.items.filter(i => !removedItems[i.id]).length} items
                    </span>
                  </div>
                  <button style={styles.removeBundleBtn} onClick={() => removeBundle(bundle.id)}>✕</button>
                </div>
                {bundle.items.filter(item => !removedItems[item.id]).map(item => (
                  <ItemRow
                    key={item.id} item={item} checked={checkedItems[item.id]}
                    onToggle={() => toggleItem(item.id)} onRemove={() => removeItem(item.id)}
                    onUpdateQuantity={delta => updateQuantity(item.id, delta)}
                    onEmojiTap={() => setEmojiPickerItemId(item.id)}
                  />
                ))}
              </div>
            ))}
            {cartItems.length > 0 && (
              <div style={styles.bundleGroup}>
                <div style={styles.groupHeader}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                    <span style={styles.groupEmoji}>🛒</span>
                    <span style={styles.groupName}>Individual items</span>
                    <span style={styles.groupCount}>
                      {cartItems.filter(i => checkedItems[i.id]).length}/{cartItems.length} items
                    </span>
                  </div>
                </div>
                {cartItems.map(item => (
                  <ItemRow
                    key={item.id} item={item} checked={checkedItems[item.id]}
                    onToggle={() => toggleCartItem(item.id)} onRemove={() => removeCartItem(item.id)}
                    onUpdateQuantity={delta => updateCartItemQuantity(item.id, delta)}
                    onEmojiTap={() => setEmojiPickerItemId(item.id)}
                  />
                ))}
              </div>
            )}
          </div>
        ) : editingCartOrder && editSections ? (
          <div>
            {GROCERY_CATEGORIES.filter(cat => editSections[cat].length > 0).map(cat => (
              <div key={cat}>
                <div style={styles.groceryGroupHeader}>{cat}</div>
                {editSections[cat].map((item, idx) => {
                  const disableUp = cat === firstNonEmptyCat && idx === 0
                  const disableDown = cat === lastNonEmptyCat && idx === editSections[cat].length - 1
                  return (
                    <div key={item.id} style={styles.reorderRow}>
                      <span style={styles.reorderEmoji}>{getItemEmoji(item)}</span>
                      <div style={styles.reorderInfo}>
                        <div style={styles.reorderName}>{item.name}</div>
                        {item.bundleName && <div style={styles.reorderSub}>{item.bundleEmoji} {item.bundleName}</div>}
                      </div>
                      <div style={styles.reorderBtns}>
                        <button style={styles.arrowBtn} onClick={() => moveItemInSection(item, -1)} disabled={disableUp}>↑</button>
                        <button style={styles.arrowBtn} onClick={() => moveItemInSection(item, 1)} disabled={disableDown}>↓</button>
                      </div>
                    </div>
                  )
                })}
              </div>
            ))}
          </div>
        ) : (
          <div>
            {itemCategoryGroups.map(group => (
              <div key={group.category}>
                <div style={styles.groceryGroupHeader}>{group.category}</div>
                {group.items.map(item => (
                  <ItemRow
                    key={item.id} item={item} checked={checkedItems[item.id]}
                    onToggle={() => cartItemIds.has(item.id) ? toggleCartItem(item.id) : toggleItem(item.id)}
                    onRemove={() => cartItemIds.has(item.id) ? removeCartItem(item.id) : removeItem(item.id)}
                    onUpdateQuantity={delta => cartItemIds.has(item.id) ? updateCartItemQuantity(item.id, delta) : updateQuantity(item.id, delta)}
                    showBundle={!cartItemIds.has(item.id)}
                    onEmojiTap={() => setEmojiPickerItemId(item.id)}
                  />
                ))}
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={styles.checkoutBar}>
        <div style={styles.storeRow}>
          <div style={styles.storeLogo}>🛒</div>
          <div style={styles.storeLabel}>Your store</div>
        </div>
        <div style={styles.checkoutAction} onClick={sendToStore}>
          <div style={{ flex: 1 }}>
            <div style={styles.checkoutMain}>Send to store</div>
            <div style={styles.checkoutSub}>{checkedCount} items selected</div>
          </div>
          <div style={styles.checkoutTotal}>${total.toFixed(2)}</div>
        </div>
      </div>

      {showClearConfirm && (
        <div style={styles.modalOverlay} onClick={() => setShowClearConfirm(false)}>
          <div style={styles.modalSheet} onClick={e => e.stopPropagation()}>
            <div style={styles.modalTitle}>Clear your cart?</div>
            <div style={{ fontSize: '13px', color: '#888', lineHeight: '1.6', marginTop: '-8px' }}>
              This removes all bundles and individual items. You can add them back anytime.
            </div>
            {cartBundles.length > 0 && (
              <button style={styles.confirmHistoryBtn} onClick={clearCartWithHistory}>
                <span style={{ fontSize: '16px' }}>📅</span>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontWeight: '500', fontSize: '14px' }}>Clear + save to history</div>
                  <div style={{ fontSize: '12px', color: '#aaa', marginTop: '2px' }}>Logs this week's bundles so the assistant can learn from your habits</div>
                </div>
              </button>
            )}
            <div style={{ display: 'flex', gap: '10px', marginTop: '12px' }}>
              <button style={styles.confirmCancelBtn} onClick={() => setShowClearConfirm(false)}>Cancel</button>
              <button style={styles.confirmClearBtn} onClick={clearCart}>Just clear</button>
            </div>
          </div>
        </div>
      )}

      {emojiPickerItemId && (
        <div style={styles.modalOverlay} onClick={() => setEmojiPickerItemId(null)}>
          <div style={styles.modalSheet} onClick={e => e.stopPropagation()}>
            <div style={styles.modalTitle}>Change emoji</div>
            <div style={styles.emojiGrid}>
              {ITEM_EMOJIS.map(e => (
                <button
                  key={e}
                  style={styles.emojiOption}
                  onClick={() => updateItemEmoji(emojiPickerItemId, e)}
                >
                  {e}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

function ItemRow({ item, checked, onToggle, onRemove, showBundle, onUpdateQuantity, onEmojiTap }) {
  return (
    <div style={styles.itemRow} onClick={onToggle}>
      <div style={{ ...styles.checkbox, ...(checked ? styles.checkboxOn : styles.checkboxOff) }}>
        {checked && (
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path d="M1.5 5.5l3 3 5-5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </div>
      <div
        style={{ ...styles.itemImg, cursor: onEmojiTap ? 'pointer' : 'default' }}
        onClick={onEmojiTap ? e => { e.stopPropagation(); onEmojiTap() } : undefined}
      >
        <span style={{ fontSize: '18px' }}>{getItemEmoji(item)}</span>
      </div>
      <div style={styles.itemInfo}>
        {showBundle && <div style={styles.itemBundle}>{item.bundleEmoji} {item.bundleName}</div>}
        <div style={styles.itemBrand}>{item.brand}</div>
        <div style={styles.itemName}>{item.name}</div>
        <div style={styles.itemSize}>{item.size}</div>
      </div>
      <div style={styles.qtyControl} onClick={e => e.stopPropagation()}>
        <button style={styles.qtyBtn} onClick={() => onUpdateQuantity && onUpdateQuantity(-1)}>−</button>
        <span style={styles.qtyNum}>{item.quantity || 1}</span>
        <button style={styles.qtyBtn} onClick={() => onUpdateQuantity && onUpdateQuantity(1)}>+</button>
      </div>
      <div style={styles.itemPrice}>${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</div>
      <button
        style={styles.removeItemBtn}
        onClick={e => { e.stopPropagation(); onRemove && onRemove() }}
      >✕</button>
    </div>
  )
}

const styles = {
  container: {
    maxWidth: '430px', margin: '0 auto', minHeight: '100vh',
    background: 'white', display: 'flex', flexDirection: 'column',
    fontFamily: "'DM Sans', sans-serif",
  },
  navBar: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '12px 20px 10px', flexShrink: 0,
  },
  backBtn: {
    fontSize: '13px', color: '#1D9E75', background: 'none',
    border: 'none', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  },
  clearCartBtn: {
    fontSize: '13px', color: '#cc4444', background: 'none',
    border: 'none', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  },
  navTitle: { fontFamily: "'DM Serif Display', serif", fontSize: '20px', color: '#1a1a18' },
  cartSearchWrap: { padding: '0 20px 10px', flexShrink: 0, position: 'relative' },
  cartSearchRow: {
    display: 'flex', alignItems: 'center', gap: '8px',
    background: '#f9f9f7', border: '0.5px solid #eee',
    borderRadius: '12px', padding: '10px 14px',
  },
  cartSearchInput: {
    flex: 1, background: 'none', border: 'none', outline: 'none',
    fontFamily: "'DM Sans', sans-serif", fontSize: '13px', color: '#1a1a18',
  },
  cartSearchClear: {
    background: 'none', border: 'none', fontSize: '12px',
    color: '#aaa', cursor: 'pointer', padding: '0 2px',
  },
  cartSearchDropdown: {
    position: 'absolute', left: 20, right: 20, top: '100%',
    background: 'white', border: '0.5px solid #eee',
    borderRadius: '14px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    overflow: 'hidden', zIndex: 50,
  },
  cartManualRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '11px 14px', borderBottom: '0.5px solid #e8f5f0',
    background: '#f4fbf8', cursor: 'pointer',
  },
  cartResultRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '11px 14px', borderBottom: '0.5px solid #f5f5f5', cursor: 'pointer',
  },
  cartResultName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  cartResultMeta: { fontSize: '11px', color: '#888', marginTop: '2px' },
  cartResultPrice: { fontSize: '13px', color: '#888', flexShrink: 0 },
  cartAddBtn: {
    width: '28px', height: '28px', borderRadius: '50%',
    border: '0.5px solid #1D9E75', background: '#E1F5EE',
    color: '#1D9E75', fontSize: '18px', fontWeight: '300',
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0,
  },
  toggleRow: {
    display: 'flex', margin: '0 20px 12px', background: '#f9f9f7',
    borderRadius: '10px', padding: '3px', flexShrink: 0,
  },
  toggleBtn: {
    flex: 1, padding: '7px', border: 'none', borderRadius: '8px',
    fontFamily: "'DM Sans', sans-serif", fontSize: '12px', color: '#888',
    background: 'none', cursor: 'pointer',
  },
  toggleBtnActive: { background: 'white', color: '#1a1a18', fontWeight: '500', border: '0.5px solid #eee' },
  content: { flex: 1, overflowY: 'auto', padding: '0 20px 8px' },
  bundleGroup: { marginBottom: '16px' },
  groupHeader: {
    display: 'flex', alignItems: 'center', gap: '8px',
    padding: '8px 0 6px', borderBottom: '0.5px solid #eee',
    marginBottom: '2px', cursor: 'pointer',
  },
  groupEmoji: { fontSize: '15px' },
  groupName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', flex: 1 },
  groupCount: { fontSize: '11px', color: '#888' },
  itemRow: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '9px 0', borderBottom: '0.5px solid #eee', cursor: 'pointer',
  },
  checkbox: {
    width: '20px', height: '20px', borderRadius: '6px',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  },
  checkboxOn: { background: '#1D9E75', border: '1.5px solid #1D9E75' },
  checkboxOff: { background: 'white', border: '1.5px solid #ddd' },
  itemImg: {
    width: '36px', height: '36px', borderRadius: '8px',
    background: '#f9f9f7', border: '0.5px solid #eee',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  },
  itemInfo: { flex: 1, minWidth: 0 },
  itemBundle: { fontSize: '10px', color: '#aaa', marginBottom: '1px' },
  itemBrand: { fontSize: '10px', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.04em' },
  itemName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18' },
  itemSize: { fontSize: '11px', color: '#888' },
  qtyControl: { display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 },
  qtyBtn: {
    width: '22px', height: '22px', borderRadius: '6px', border: '0.5px solid #ddd',
    background: '#f9f9f7', fontSize: '14px', cursor: 'pointer', display: 'flex',
    alignItems: 'center', justifyContent: 'center', color: '#1a1a18', fontFamily: "'DM Sans', sans-serif",
  },
  qtyNum: { fontSize: '13px', fontWeight: '500', color: '#1a1a18', minWidth: '16px', textAlign: 'center' },
  itemPrice: { fontSize: '12px', color: '#888', flexShrink: 0 },
  checkoutBar: {
    margin: '6px 20px 14px', border: '0.5px solid #eee',
    borderRadius: '16px', overflow: 'hidden', flexShrink: 0,
  },
  storeRow: {
    display: 'flex', alignItems: 'center', gap: '9px',
    padding: '9px 14px', borderBottom: '0.5px solid #eee',
  },
  storeLogo: {
    width: '24px', height: '24px', borderRadius: '6px', background: '#003DA5',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'DM Sans', sans-serif", fontSize: '8px', fontWeight: '500',
    color: 'white', flexShrink: 0,
  },
  storeLabel: { fontSize: '12px', fontWeight: '500', color: '#1a1a18', flex: 1 },
  checkoutAction: {
    display: 'flex', alignItems: 'center',
    padding: '12px 14px', background: '#1D9E75', cursor: 'pointer',
  },
  checkoutMain: { fontSize: '14px', fontWeight: '500', color: 'white' },
  checkoutSub: { fontSize: '11px', color: 'rgba(255,255,255,0.8)' },
  checkoutTotal: { fontFamily: "'DM Serif Display', serif", fontSize: '20px', color: 'white' },
  removeBundleBtn: {
    background: 'none', border: 'none', fontSize: '12px', color: '#ccc',
    cursor: 'pointer', padding: '4px 2px', fontFamily: "'DM Sans', sans-serif", flexShrink: 0,
  },
  removeItemBtn: {
    background: 'none', border: 'none', fontSize: '11px', color: '#ccc',
    cursor: 'pointer', padding: '4px', flexShrink: 0, fontFamily: "'DM Sans', sans-serif",
  },
  editOrderRow: {
    display: 'flex', justifyContent: 'flex-end', padding: '0 20px 6px', flexShrink: 0,
  },
  editOrderBtn: {
    background: 'none', border: 'none', fontSize: '12px', color: '#1D9E75',
    cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", padding: '0',
  },
  reorderRow: {
    display: 'flex', alignItems: 'center', gap: '12px',
    padding: '10px 0', borderBottom: '0.5px solid #eee',
  },
  reorderEmoji: { fontSize: '20px', flexShrink: 0 },
  reorderInfo: { flex: 1, minWidth: 0 },
  reorderName: { fontSize: '13px', fontWeight: '500', color: '#1a1a18' },
  reorderSub: { fontSize: '11px', color: '#aaa', marginTop: '2px' },
  reorderBtns: { display: 'flex', gap: '6px', flexShrink: 0 },
  arrowBtn: {
    width: '30px', height: '30px', borderRadius: '8px', border: '0.5px solid #ddd',
    background: '#f9f9f7', fontSize: '14px', cursor: 'pointer', color: '#1a1a18',
    fontFamily: "'DM Sans', sans-serif", display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  groceryGroupHeader: {
    fontSize: '10px', fontWeight: '600', color: '#aaa',
    textTransform: 'uppercase', letterSpacing: '0.08em',
    padding: '10px 0 4px', borderBottom: '0.5px solid #eee', marginBottom: '2px',
  },
  emptyScreen: {
    flex: 1, display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', padding: '28px', textAlign: 'center',
  },
  emptyTitle: { fontSize: '20px', fontWeight: '500', color: '#1a1a18', marginBottom: '8px' },
  emptySub: { fontSize: '13px', color: '#888', lineHeight: '1.7', maxWidth: '260px', marginBottom: '20px' },
  emptyText: { fontSize: '14px', color: '#aaa' },
  browsBtn: {
    padding: '12px 24px', background: '#1D9E75', color: 'white', border: 'none',
    borderRadius: '12px', fontFamily: "'DM Sans', sans-serif", fontSize: '14px', fontWeight: '500', cursor: 'pointer',
  },
  successScreen: {
    flex: 1, display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', padding: '28px', textAlign: 'center', gap: '12px',
  },
  successIcon: {
    width: '68px', height: '68px', borderRadius: '50%', background: '#E1F5EE',
    display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '6px',
  },
  successTitle: { fontFamily: "'DM Serif Display', serif", fontSize: '28px', color: '#1a1a18' },
  successSub: { fontSize: '13px', color: '#888', lineHeight: '1.7', maxWidth: '260px' },
  notifPill: {
    background: '#E1F5EE', borderRadius: '20px', padding: '6px 14px',
    fontSize: '12px', fontWeight: '500', color: '#0F6E56',
  },
  successActions: { width: '100%', display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '8px' },
  krogerBtn: {
    display: 'block', padding: '13px', background: '#003DA5', color: 'white',
    borderRadius: '14px', border: 'none', fontSize: '14px', fontWeight: '500',
    fontFamily: "'DM Sans', sans-serif", cursor: 'pointer', width: '100%',
  },
  historyNote: {
    padding: '12px 14px', background: '#f9f9f7', borderRadius: '12px',
    fontSize: '12px', color: '#888', lineHeight: '1.6',
  },
  homeBtn: {
    padding: '11px', background: 'none', border: '0.5px solid #ddd', borderRadius: '12px',
    fontFamily: "'DM Sans', sans-serif", fontSize: '13px', color: '#888', cursor: 'pointer', width: '100%',
  },
  modalOverlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 100,
    display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
  },
  modalSheet: {
    background: 'white', borderRadius: '20px 20px 0 0', padding: '24px 20px 32px',
    width: '100%', maxWidth: '430px',
  },
  modalTitle: {
    fontFamily: "'DM Serif Display', serif", fontSize: '20px', color: '#1a1a18', marginBottom: '16px',
  },
  emojiGrid: {
    display: 'flex', flexWrap: 'wrap', gap: '4px',
  },
  emojiOption: {
    width: '44px', height: '44px', fontSize: '22px', background: '#f9f9f7',
    border: '0.5px solid #eee', borderRadius: '10px', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  confirmCancelBtn: {
    flex: 1, padding: '12px', background: 'none', border: '0.5px solid #ddd',
    borderRadius: '12px', fontFamily: "'DM Sans', sans-serif", fontSize: '14px',
    color: '#888', cursor: 'pointer',
  },
  confirmClearBtn: {
    flex: 1, padding: '12px', background: '#cc4444', border: 'none',
    borderRadius: '12px', fontFamily: "'DM Sans', sans-serif", fontSize: '14px',
    fontWeight: '500', color: 'white', cursor: 'pointer',
  },
  confirmHistoryBtn: {
    width: '100%', marginTop: '16px', padding: '12px 14px',
    background: '#f4fbf8', border: '0.5px solid #1D9E75', borderRadius: '12px',
    fontFamily: "'DM Sans', sans-serif", color: '#0F6E56', cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: '12px',
  },
}
